import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { EDITOR, VIEW_ONLY } = PERMISSIONS_OPTIONS_VALUE;

export const PAGES_PERMISSIONS = {
  [VIEW_ONLY]: {
    HIDE_CREATE_PAGE: true,
    HIDE_ACTIONS_MENU: true,
    DIM_VISIBILITY_TOGGLE: true
  },
  [EDITOR]: {
    HIDE_DELETE_PAGE: true,
    DIM_VISIBILITY_TOGGLE: true
  }
};
